import React, { FC } from 'react';
import Form from 'components/Form';

import { BonjelaPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Bonjela: FC<BonjelaPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Bonjela;
